import { ApplicationConfig, ErrorHandler } from '@angular/core';
import {
  NavigationError,
  PreloadAllModules,
  provideRouter,
  Router,
  withNavigationErrorHandler,
  withPreloading,
} from '@angular/router';
import * as Sentry from '@sentry/angular';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withI18nSupport,
} from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BaseUrlInterceptor } from './config/interceptor/base-url.interceptor';
import { AcceptHeaderInterceptor } from './config/interceptor/accept-header.interceptor';

import cs from '@angular/common/locales/cs';
import de from '@angular/common/locales/de';
import es from '@angular/common/locales/es';
import fr from '@angular/common/locales/fr';
import hi from '@angular/common/locales/hi';
import hr from '@angular/common/locales/hr';
import it from '@angular/common/locales/it';
import en from '@angular/common/locales/en';
import ka from '@angular/common/locales/ka';
import kk from '@angular/common/locales/kk';
import pl from '@angular/common/locales/pl';
import pt from '@angular/common/locales/pt';
import ro from '@angular/common/locales/ro';
import ru from '@angular/common/locales/ru';
import sr from '@angular/common/locales/sr';
import sv from '@angular/common/locales/sv';
import tr from '@angular/common/locales/tr';
import uk from '@angular/common/locales/uk';
import zh from '@angular/common/locales/zh';
import { RetryInterceptor } from './config/interceptor/retry.Interceptor';
import { provideNzConfig } from 'ng-zorro-antd/core/config';
import { EMPTY } from './util/const';

registerLocaleData(cs);
registerLocaleData(de);
registerLocaleData(es);
registerLocaleData(fr);
registerLocaleData(hi);
registerLocaleData(hr);
registerLocaleData(it);
registerLocaleData(en);
registerLocaleData(ka);
registerLocaleData(kk);
registerLocaleData(pl);
registerLocaleData(pt);
registerLocaleData(ro);
registerLocaleData(ru);
registerLocaleData(sr);
registerLocaleData(sv);
registerLocaleData(tr);
registerLocaleData(uk);
registerLocaleData(zh);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withNavigationErrorHandler((error: NavigationError): void => {
        const message: string = error.error?.message ?? EMPTY;
        if (message.match(/Failed to fetch dynamically imported module/i)) {
          window.location.reload();
        }
      })
    ),
    provideClientHydration(withI18nSupport()),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimations(),
    provideNzConfig({
      message: {
        nzDuration: 5000,
      },
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        logErrors: true,
        showDialog: true,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AcceptHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true,
    },
  ],
};
